module.exports = __webpack_public_path__ + "static/media/karajan_dashboard_web_background_blur.29358fa1.jpg";